<template>
  <div class="legal-cases">
    <b-card no-body>
      <b-card-header class="py-2 px-3">
  <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                            Historical Enquiry
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_history_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>      </b-card-header>

      <div v-if="pivotHistoricalEnquiry.length > 0" class="rounded-bottom">
        <el-table :data="pivotHistoricalEnquiry" border style="width: 100%" :span-method="tableSpanMethod">
        <el-table-column prop="year" label="Year" width="80"/>
        <el-table-column prop="rowType" label="Type" width="100"/>
        <el-table-column
          v-for="m in monthNames"
          :key="m"
          :prop="m"
          :label="m"
          align="center"
        />
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded-bottom">
        <p class="text-xs">No Historical enquiries recorded</p>
      </div>
    </b-card>
        <HistoricalEnquiryModal
            :historical-enquiry="historicalEnquiry" 
            :show_history_full_view.sync="modals.show_history_full_view"
        />
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui'
import HistoricalEnquiryModal from '@/views/CustomerProfile/CustomerModals/HistoricalEnquiryModal.vue'

export default {
  name: 'historicalEnquiry',
  props: {
    historicalEnquiry: {
      type: Array,
      default: () => []
    }
  },
  components: {
    HistoricalEnquiryModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
data() {
  return {
    monthNames: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    modals: {
      show_history_full_view: false
    }
  }
},

  computed: {
    pivotHistoricalEnquiry() {
      if (!this.historicalEnquiry) return []

      const rows = []

      this.historicalEnquiry.forEach(yearBlock => {
        const year = yearBlock['@attributes']?.year

        // Initialize rows for this year
        const rowFI = { year, rowType: 'FI' }
        const rowNonFI = { year, rowType: 'Non-FI' }
        const rowLawyer = { year, rowType: 'Lawyer' }
        const rowTotal = { year, rowType: 'Total' }

        // Fill month columns
        yearBlock.period.forEach(period => {
          const monthIdx = parseInt(period['@attributes']?.month, 10) - 1
          const monthName = this.monthNames[monthIdx]

          let fi = 0, nonfi = 0, lawyer = 0
          period.entity.forEach(e => {
            const type = e['@attributes']?.type
            const val = parseInt(e['@attributes']?.value || 0, 10)
            if (type === 'FI') fi = val
            if (type === 'NON-FI') nonfi = val
            if (type === 'LAWYER') lawyer = val
          })

          rowFI[monthName] = fi
          rowNonFI[monthName] = nonfi
          rowLawyer[monthName] = lawyer
          rowTotal[monthName] = fi + nonfi + lawyer
        })

        rows.push(rowFI, rowNonFI, rowLawyer, rowTotal)
      })

      return rows
    }
  },
  methods: {
  tableSpanMethod({ row, column, rowIndex, columnIndex }) {
    if (column.property === 'year') {
      // group every 4 rows under same year
      if (rowIndex % 4 === 0) {
        return [4, 1]  // rowspan=4, colspan=1
      } else {
        return [0, 0]  // hide repeated cells
      }
    }
  },
  toggleModal() {
      this.modals.view_full = !this.modals.view_full
  }
}

}
</script>